<template>
  <span
    v-if="hasDrift"
    :onclick="driftOnClick"
    style="cursor: pointer"
  >
    <slot />
  </span>

  <InternalLink
    v-else
    v-bind="fallbackLink"
  >
    <slot />
  </InternalLink>
</template>

<script setup lang="ts">
import type { DriftAction } from '~/sanity/types';

const { hasDrift, showDriftBotOrThrow, openDrift } = useDrift();
const { fallbackLink, action } = defineProps<DriftAction>();

const { user, setParamsForFetch } = useCrossSession();
setParamsForFetch({ params: ['currentUserData'] });

const personalizationProfile = useWwwStorage().personalizationProfileStorable;
const persistedProgressiveProfile = personalizationProfile.value?.persistedProgressiveProfile;

const { getResolvedInternalLinkRef } = useRefsStore();
const resolvedFallbackLink = await getResolvedInternalLinkRef(
  fallbackLink?.selectedPage?.reference?._ref
);
const fallbackLinkUrl = computed(() => {
  if (!resolvedFallbackLink.value) {
    return '#';
  }
  return `${resolvedFallbackLink.value.currentPathname}${fallbackLink?.query ? '?' + fallbackLink.query : ''}`;
});

const resolvedRedirectLink = await getResolvedInternalLinkRef(
  action?.redirectUrl?.selectedPage?.reference?._ref
);
const redirectLinkUrl = computed(() => {
  if (!resolvedRedirectLink.value) {
    return '#';
  }
  return `${resolvedRedirectLink.value.currentPathname}${action?.redirectUrl?.query ? '?' + action.redirectUrl.query : ''}`;
});

const driftOnClick = () => {
  if (!hasDrift || !action) {
    window.location.href = fallbackLinkUrl.value;
    return;
  }

  if (action.driftActionName === 'Open Chat') {
    openDrift();
    return;
  }

  const playbookId = action.playbookId;

  if (action.driftActionName === 'Trigger Playbook') {
    if (!user.value || !persistedProgressiveProfile || !playbookId) return;
    const { firstName, lastName, email } = user.value;

    const profile: DriftSubmissionData = {
      firstName: firstName || persistedProgressiveProfile.firstName || '',
      lastName: lastName || persistedProgressiveProfile.lastName || '',
      email: email || persistedProgressiveProfile.email || '',
    };

    showDriftBotOrThrow({
      playbookId,
      redirectUrl: redirectLinkUrl.value,
      submissionData: profile,
    });
    return;
  }
};
</script>
